<template>
  <div class='dialog-main' @touchmove.capture="dialogTouchMove($event)">
    <div class='bg-black'></div>
    <div class='Popup'>
      <div class='Popup1'>
        <div class='p_title'>{{title}}</div>
        <div class='p_content'>
          <div class='err_or_right' v-if="tip">
            <div class='close-icon error'><i class="iconfont icon-icon_wrong"></i></div>
            <span>{{tip}}</span>
          </div>
          <div class="t_999" v-html="msg"></div>
        </div>
        <div class='p_content-btm'>
          <div class="p_content-btn w_50" v-if="showCancelBtn" @click="cancel">{{cancelText}}</div>
          <div class="p_content-btn w_50 sure" @click="confirm">{{confirmText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    title: {
      type: String,
      require: true,
      default: '提示'
    },
    tip: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      require: true,
      default: ''
    },
    showCancelBtn: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    }
  },
  methods: {
    dialogTouchMove (e) {
      e.preventDefault()
    },
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
  .bg-black{
    width: 100%;
    height: 100%;
    position: fixed;
    background: #000;
    opacity: 0.5;
    top: 0;
    left: 0;
    z-index: 900;
  }
  .Popup{
    position:fixed;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    z-index: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: dialogAnim .2s ease-in;
    animation-fill-mode: backwards;
  }
  .Popup1{
    width: 80%;
    background: #fff;
    border-radius: 4px;
    padding: 15px 0 0;
  }
  .p_title{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .p_content{
    padding: 0 20px;
    margin: 15px 0 0 0;
    font-size: 15px;
  }
  .err_or_right{
    display: flex;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .err_or_right .close-icon{
    margin-right: 10px;
    display: block;
    flex-shrink: 0;
    float: left;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
  }
  .close-icon .iconfont{font-size: 12px;vertical-align: middle;}
  .err_or_right .error{
    background: #f23030;
  }
  .err_or_right .success{
    background: #09BB07;
  }
  .p_content-btm{
    display: flex;
    align-items: center;
    height: 45px;
    margin-top: 10px;
    line-height: 45px;
    font-size: 15px;
    text-align: center;
    border-top: 1px solid #eee;
  }
  .p_content-btm .p_content-btn{
    flex-grow: 1;
  }
  .p_content-btm .sure{
    color: #108DF1;
    border-left: 1px solid #ddd;
  }
  .w_50{
    width: 50%;
  }
  .feedback-btn{
    color: #108DF1;
    cursor: pointer;
  }
  @keyframes dialogAnim{
    0%{
      opacity: 0;
      transform: scale(0.2);
    }
    100%{
      opacity: 1;
      transform: scale(1);
    }
  }
</style>
